import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import smsService from "../../../api/reservePlanNew.service";
import moment from "moment";
import rules from "../../../utils/rules";
import telematicsService from "../../../api/telematics.service";
import schedulerDialog from "@/components/SchedulerDialog";

export default {
  name: "customer-balance-report",
  components: { pageheader, schedulerDialog },
  data() {
    return {
      input: {},
      loadergetcalls: false,
      reportsList: [],
      selected: ["Jobsite", "Search Field"],
      selectedMachine: [],
      filterTypes: [
        { id: "5", name: "Jobsite" },
        { id: "7", name: "Search Field" },
      ],
      isReportLoading: false,
      loadingMachines: false,
      machineSearchFilter: null,
      machines: [],
      zoneSearchFilter: "",
      groupSearchFilter: "",
      groups: [],
      selectedGroup: [],
      jobSiteSearchFilter: "",
      locations: [],
      jobSiteList: [],
      loadinglocations: false,
      selectedJobSite: [],
      selectedJobSiteNames: [],
      selectedZone: [],
      zonesList: [],
      modelSearchFilter: "",
      models: [],
      selectedModel: [],
      searchMenu: false,
      searchEquipName: "",
      searchPO: "",
      searchJob: "",
      searchContractId: "",
      nodataMachine: false,
      showmachinmsg: true,
      fromDate: "",
      toDate: new Date().toISOString().slice(0, 10),
      search: "",
      menu1: false,
      menu2: false,
      isReportExporting: false,
      showTable: false,
      header: [
        { text: "Customer Name", value: "name" },
        { text: "Contract #", value: "cntr" },
        { text: "Contract Status", value: "status" },
        { text: "Opened", value: "opened" },
        { text: "Closed", value: "closed" },
        { text: "<31", value: "under31" },
        { text: "31-60", value: "thirtyOneToSixty" },
        { text: "61-90", value: "sixtyOneToNinty" },
        { text: ">90", value: "over90" },
        { text: "Jobsite", value: "jobsite" },
        { text: "Job #", value: "jobNo" },
        { text: "PO #", value: "poNo" },
      ],
      smsCustomersList: [],
      selectedSMSCustomer: "",
      isCustLoad: false,
      csvName: "Customer Balance.xlsx",
      pdfName: "Customer Balance.pdf",
      isDownloadCSV: false,
      errorMSG: "Please select customer to run the report",
      // scheduled reports data fields
      jobSiteSearchFilterSchedule: "",
      searchContractIdSchedule: "",

      searchemail: null,
      emailitems: [],
      emails: [],
      Scheduledheader: [
        { text: "Company", value: "customerName", width: "10px" },

        { text: "Name", value: "name", width: "10px" },

        { text: "Format", value: "format", width: "10px" },
        { text: "Frequency", value: "frequency", width: "10px" },

        { text: "Emails", value: "emails", width: "10px" },
        { text: "Action", value: "action", width: "10px" },
      ],
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      scheduledFrequency: "",
      FrequencyListDropDown: ["Daily", "Weekly", "Biweekly", "Monthly"],
      scheduledTypeListDropdown: ["Excel"],
      scheduledType: "",

      zoneSearchFilterSchedule: "",
      menufilterSchedule: false,
      modelSearchFilterSchedule: "",
      machineSearchFilterSchedule: null,
      groupSearchFilterSchedule: "",
      accessControlCodesSearchFilterSchedule: "",
      selectedOwnershipTypeSchedule: ["1", "2"],
      selectedOwnershipFinalSchedule: "",
      searchFieldSchedule: "",
      searchSchedule: "",
      ScheduleReportName: "CUSTOMERBALANCE",
      searchMenuSchedule: false,
      selectedschedule: {},
      scheduleedit: false,
      dailyUtilizationTargetSchedule: 0,
      selectedTimeSchedule: "Hours",
      selectedZonesNamesSchedule: [],
      selectedJobSiteNamesSchedule: [],
      selectedModelNamesSchedule: [],
      timeSearchFilterSchedule: "",
      selectedAccessControlCodesNamesSchedule: [],
      selectedGroupSchedule: [],
      selectedModelSchedule: [],
      selectedAccessControlCodesSchedule: [],
      selectedJobSiteSchedule: [],
      selectedMachineSchedule: [],
      selectedZoneSchedule: [],
      displayScheduledForm: false,
      scheduledialog: false,
      confirmdialog: false,
      isdelete: false,
      scheduleformvalid: true,
      isSaveScheduleLoading: false,
      isupdateScheduleLoading: false,
      scheduleName: "",
      selectedcust: "",
      scheduledList: [],
      isScheduledListLoading: false,
      ScheduledWeekDaysList: [
        {
          name: "Sunday",
          value: "0",
        },
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
      ],
      selectedDays: [],
      custnum: "",
      custid: "",
      rules: rules,
      exportOptions: ["Excel", "PDF"],
      selectedExportOption: null,
      isDownloading: false,
      closeOnContentClick: false,
      menufilter: false,
      loading: false,
      // end scheduled reports data fields
    };
  },
  watch: {
    machineSearchFilter(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
    machineSearchFilterSchedule(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCNum",
      "smsCustomerId",
      "smsUserId",
      "smsCustomerLinkingId",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
  },
  async mounted() {
    this.input = utils.getInputContent("customerbalanceReport", this.roles);
    this.loadergetcalls = false;
    await this.getLocations();
    this.loadergetcalls = true;

    //Load report on page load
    this.getReportList();
  },
  methods: {
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    mindate() {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 1))
        .toISOString()
        .slice(0, 10);
    },
    maxdate() {
      return new Date().toISOString().slice(0, 10);
    },
    async getReportList() {
      this.isReportLoading = true;
      try {
        let response = await smsService.getCustomerBalanceReport(
          this.selectedJobSiteNames,
          this.searchPO,
          this.searchJob,
          this.searchContractId
        );
        if (response.isSuccess && response.data.length > 0) {
          this.showTable = true;
          this.reportsList = response.data;
          this.isReportLoading = false;
        } else {
          this.reportsList = [];
          this.isReportLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
      }
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = new Date().toISOString().slice(0, 10);
      this.reportsList = [];
      this.selectedGroup = [];
      this.selectedMachine = [];
      this.selectedModel = [];
      this.selectedZone = [];
      this.selectedJobSite = [];
      this.selectedJobSiteNames = [];
      this.searchEquipName = "";
      this.searchPO = "";
      this.searchJob = "";
      this.searchContractId = "";
      this.getReportList();
    },
    async downloadReport(exportOption) {
      try {
        let response = await smsService.exportCustomerBalanceReport(
          exportOption,
          this.selectedJobSiteNames,
          this.searchPO,
          this.searchJob,
          this.searchContractId
        );
        if (response) {
          if (exportOption == this.exportOptions[0]) {
            //excel
            utils.downloadExcelFile(response, this.csvName);
          } else {
            //pdf
            utils.downloadPDFFile(response, this.pdfName);
          }
        } else {
          this.$toast.error(
            "Unable to download the report. Please contact admin."
          );
        }
        this.isDownloading = false;
      } catch (error) {
        this.$toast.error(
          "Unable to download the report. Please contact admin."
        );
        this.isDownloading = false;
      }
    },
    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.downloadReport(this.exportOptions[0]);
        } else if (this.selectedExportOption == this.exportOptions[1]) {
          //case  "Pdf"
          this.downloadReport(this.exportOptions[1]);
        }
      }
    },
    // scheduled reports api calls

    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    showScheduledForm() {
      this.scheduleedit = false;
      this.clearSchedule();
      this.displayScheduledForm = true;
    },
    cancelSchedule() {
      this.displayScheduledForm = false;
      this.scheduleedit = false;

      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledType = "";

      this.searchFieldSchedule = "";
      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    closeSchedule() {
      this.scheduledialog = false;
      this.clearSchedule();
    },
    clearSchedule() {
      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledType = "";

      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    openScheduledDialog() {
      this.$refs.modal.showScheduleModal();
    },
    OnFrequencyChange() {
      this.selectedDays = [];
    },
    // end scheduled reports methods
    async searchMachines(value) {
      let machineValue = "";
      machineValue = encodeURIComponent(value);
      this.machines = [];
      try {
        this.loading = true;
        let response = await telematicsService.getTelematicMachinesnew(
          machineValue
        );
        if (response && response.data.length != 0) {
          this.machines = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              tuUnitId: item.tuUnitId ? item.tuUnitId : "",
              machine: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });
          this.loading = false;
        } else {
          this.nodataMachine = true;
          this.showmachinmsg = false;
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        this.nodataMachine = true;
        this.showmachinmsg = false;
        console.log(err);
      }
    },
    async getZones() {
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
        } else {
          this.zonesList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = this.locations = response.data.filter(
            (e) => e.locationName != null
          );
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    async getModels() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

          this.loadingmodel = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getJobSites() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = response.data.filter(
            (e) => e.locationName != null
          );
        } else {
          this.jobSiteList = [];
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    clearDates() {
      if (this.fromDate) {
        this.fromDate = "";
      }
      if (this.toDate) {
        this.toDate = "";
      }
    },
    resetGroup() {
      this.selectedGroup = [];
    },
    resetMachine() {
      this.selectedMachine = [];
    },
    resetZone() {
      this.selectedZone = [];
    },
    resetJobSite() {
      this.selectedJobSite = [];
      this.jobSiteChange();
    },
    resetModel() {
      this.selectedModel = [];
    },
    clearSearchEquipName() {
      this.searchEquipName = "";
    },
    clearSearch() {
      this.searchPO = "";
    },
    clearSearchJob() {
      this.searchJob = "";
    },
    clearSearchContractId() {
      this.searchContractId = "";
    },
    zoneChange() {
      this.selectedZonesNames = [];
      this.selectedZonesNames = this.selectedZone.map(
        (id) => this.zonesList.find((el) => el.id == id).name
      );
    },
    modelChange() {
      this.selectedModelNames = [];
      this.selectedModelNames = this.selectedModel.map(
        (id) => this.models.find((el) => el.id == id).name
      );
    },
    jobSiteChange() {
      this.selectedJobSiteNames = [];
      this.selectedJobSiteNames = this.selectedJobSite.map(
        (locationId) =>
          this.locations.find((el) => el.locationId == locationId).locationName
      );
    },
  },
};
